var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5086 13.7075H14.56L14.2238 13.3834C15.4412 11.9714 16.1102 10.1688 16.1089 8.30446C16.1089 6.76089 15.6512 5.25197 14.7936 3.96854C13.9361 2.6851 12.7172 1.68478 11.2911 1.09408C9.86502 0.503382 8.2958 0.348827 6.78189 0.649964C5.26797 0.951101 3.87735 1.6944 2.78588 2.78588C1.6944 3.87735 0.951101 5.26797 0.649964 6.78189C0.348827 8.2958 0.503382 9.86502 1.09408 11.2911C1.68478 12.7172 2.6851 13.9361 3.96854 14.7936C5.25197 15.6512 6.76089 16.1089 8.30446 16.1089C10.2376 16.1089 12.0146 15.4005 13.3834 14.2238L13.7075 14.56V15.5086L19.711 21.5L21.5 19.711L15.5086 13.7075ZM8.30446 13.7075C5.31475 13.7075 2.90138 11.2942 2.90138 8.30446C2.90138 5.31475 5.31475 2.90138 8.30446 2.90138C11.2942 2.90138 13.7075 5.31475 13.7075 8.30446C13.7075 11.2942 11.2942 13.7075 8.30446 13.7075Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.4cafd6a1a532b0e7d7464770e3ad4521.svg";
export { ForwardRef as ReactComponent };